function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  transform: "translate(1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M94.476 59.704c-3.859 6.744-5.793 11.227-5.793 13.343a5.793 5.793 0 0011.586 0c0-2.116-1.934-6.599-5.793-13.343zm.817 39.298c-3.86 6.744-5.793 11.227-5.793 13.343a5.793 5.793 0 1011.586 0c0-2.116-1.934-6.599-5.793-13.343z"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M133.834 5.315H72.647M27.883 5.315H4.804M28.717 44.289H.411M138.564 44.289H72.44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.12 44.709l4.52-7.987-10.92-6.219 6.4-11.606"
}), /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 49,
  x: 28.638,
  y: 0.5,
  rx: 3,
  transform: "matrix(-1 0 0 1 101.276 0)"
}));

function SvgRoomPlumbingLeak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141,
    height: 119,
    viewBox: "0 0 141 119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomPlumbingLeak);
export default __webpack_public_path__ + "static/media/RoomPlumbingLeak.75ba4111.svg";
export { ForwardRef as ReactComponent };